import { Injectable } from "@angular/core";

@Injectable()
export class FilterLogDto {
    public searchText: string;
    public filterType: String;
}